import React, { useCallback, useMemo } from "react";
import { navigate, useBasePath } from "raviger";
import { useSelector } from "react-redux";
import questionAnimation from "./Animations";
// import { isEmpty } from "lodash";
import { Button } from "./Fields";

import "./DesktopPage.scss";
import Question from "./Question";

export default function DesktopPage({
	pageData,
	handleBackButton,
	handleNextButton,
}) {
	const basepath = useBasePath();

	// used only to remove back button at first question
	const currentQuestionId /*: number */ = useSelector(
		(state) => state.navigation.currentQuestion,
	);

	const currentQuestion = useMemo(() => {
		return pageData.questions.find(
			(question) => String(question.id) === String(currentQuestionId),
		);
	}, [currentQuestionId, pageData]);

	const answers = useSelector((state) => state.answers);

	const Animation = useMemo(() => {
		return questionAnimation[currentQuestionId];
	}, [currentQuestionId]);

	const isQuestionAnswered = useCallback(
		(question) => {
			// if answers store object contains an array with atleast one element, then question is answered
			return answers[question.id].touched;
		},
		[answers],
	);

	// hold answers
	const currentQuestionAnswer = answers[currentQuestionId];

	//boolean
	const pageAnswered = useMemo(() => {
		// returns true if page has been answered
		return pageData.questions
			.map((question) => {
				// if question is nested,
				if (question.parent_id > 0) {
					// then check if the parent has choosen the correct answer first
					const parentId = question.parent_id;
					// if the parent choosed the correct answer
					if (
						String(
							answers[parentId].answer.map((answer) => answer.id).join(),
						) === String(question.required_parent_answer_id)
					) {
						// then check if the nested question has been answered
						return isQuestionAnswered(question);
					}
					// else, parent hasn't choosen the correct answer (nested answer isn't visible)
					else {
						// it's okay, answer isn't required
						return true;
					}
				}
				// if question not nested
				else {
					// then just check if it has been answered or not
					return isQuestionAnswered(question);
				}
			})
			.every((isQuestionAnswered) => isQuestionAnswered);
	}, [answers, pageData, isQuestionAnswered]);

	return (
		<div className="page-container">
			<div className="questions-container">
				{pageData.questions.map((questionData, index) => {
					if (
						questionData.parent_id > 0 &&
						String(questionData.required_parent_answer_id) !==
							String(
								answers[questionData.parent_id].answer
									.map((answer) => answer.id)
									.join(),
							)
					)
						return null;
					else
						return (
							<Question
								key={questionData.id}
								question={questionData}
							/>
						);
				})}

				<div className="page-buttons">
					{currentQuestionId !== "1" && (
						<Button onClick={handleBackButton} label="Back" />
					)}
					{currentQuestionId === "1" && (
						<Button
							onClick={() => navigate(basepath + "/")}
							label="Back"
						/>
					)}

					<Button
						onClick={handleNextButton}
						disabled={!pageAnswered}
						label="Continue"
					/>
				</div>
			</div>
			<div className="animation-container desktop">
				<Animation
					value={currentQuestionAnswer.answer.map((a) => a.text).join()}
					options={currentQuestion.answers.map(
						(answer) => answer.text,
					)}
				/>
			</div>
		</div>
	);
}
